module.exports = __webpack_public_path__ + "assets/images/key-on.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/key-on.png
// module id = 251
// module chunks = 1